import { SearchspringFetcher } from 'libs/searchspring/classes/searchspring-fetcher'
import { normaliseResults, adjustPagination } from 'libs/searchspring/helpers/normalisers'
import { generateSearchspringProvider } from 'libs/searchspring/fetchers/provider'

export class SearchspringProduct extends SearchspringFetcher {
  generateURL() {
    const endpoint = '/api/search/search.json'
    return super.generateURL(endpoint)
  }

  updateParams(options = {}) {
    const { handle } = options

    this.params.setDomainParam()
    this.params.set('resultsFormat', 'native')
    this.params.set('redirectResponse', 'full')
    this.params.set('resultsPerPage', 1)
    this.params.set('bgfilter.handle', handle)

    super.updateParams()
  }
}

export const SearchspringProductProvider = generateSearchspringProvider(SearchspringProduct, async (results) => {
  const normalisedResults = await normaliseResults(results.results)
  return adjustPagination(results, normalisedResults)
})
